export default {
  201: 'Día festivo creado',
  202: 'Día festivo editado',
  403: 'No se pueden borrar días festivos pasados',
  404: 'Día festivo no encontrado',
};
